module.exports = __webpack_public_path__ + "static/media/eas_svg.44bdad92.png";